import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9h-2a3 3 0 1 1 0 -6h7","key":"svg-0"}],["path",{"d":"M11 3v11","key":"svg-1"}],["path",{"d":"M15 3v11","key":"svg-2"}],["path",{"d":"M3 18h18","key":"svg-3"}],["path",{"d":"M6 15l-3 3l3 3","key":"svg-4"}]]

const IconPilcrowLeft = createReactComponent('outline', 'pilcrow-left', 'PilcrowLeft', __iconNode);

export default IconPilcrowLeft;